crminfo = require('./crminfo.production').default

crminfo.enableTags = true
crminfo.isGeekly = true
crminfo.apiHostSmsTool = 'https://gh-connect.dsh-agency.com'
crminfo.baseUrlWFH = 'https://connect.dsh-agency.com'
crminfo.templateMessages = 'templateMessages.geekly';
crminfo.showOfferSubscription = false;

defaultConfig = require('./default-config')({
  domain: 'gh-connect.dsh-agency.com',
  protocol: 'https',
  sentry: true,
  updateNotification: true,
  crmUrl: 'https://a4.dsh-agency.com/api/v1/crminfo',
  crmUrlA5: 'https://api.dsh-agency.com/api/v3'
  GMTOffset: '+0300',
  crmPluginEnabled: true,
  oauthEnabled: true
  authApiHost: 'https://oauth.dsh-agency.com'
  authBackApiHost: 'https://auth-back.dsh-agency.com'
  fileServerUrl: 'https://nwzc6p9uv6.execute-api.eu-west-1.amazonaws.com/production_v1'
  mqttUrl: 'wss://gh-connect.dsh-agency.com:8084/mqtt'
  crminfo: crminfo
  dashboardTags: false
  analyticByChannelType: true
  isProductionMode: true
  xmpp: false
  isGeekly: true
  showRankingRules: true
  showTotalActiveConversationsSales: false
  showUnreadMessages: true
})

module.exports = _.extend defaultConfig, {}
